<div class="filters a-fx a-fx-gap-16 a-fx-between-center">
    <nz-spin *ngIf="processing" class="filters-spin" nzSimple></nz-spin>

    <div class="filters-wrap">
        <ng-container *ngFor="let item of selectedFilters; trackBy: trackByKey">
            <span
                class="filters-item a-fx a-fx-center-center a-fx-gap-8 a-bg-color-light-blue a-color-white"
                nz-dropdown
                nzOverlayClassName="selected-subfilter"
                [nzClickHide]="false"
                nzTrigger="click"
                (nzVisibleChange)="onSelectedFilterMenuChange($event, item)"
                [(nzVisible)]="item.isMenuVisible"
                [nzDropdownMenu]="selectedMenuContentTemplate"
            >
                <span class="a-text-overflow-ellipsis a-text-no-wrap">{{ item | displayFilterSelection }}</span>

                <svg class="adspt-icon" (click)="removeSelectedFilter(item)">
                    <use xlink:href="#adspt-cross"></use>
                </svg>
            </span>
            <nz-dropdown-menu #selectedMenuContentTemplate="nzDropdownMenu">
                <div
                    class="selected-filter-menu menu-wrapper"
                    [ngClass]="{ disabled: !!item.disabled }"
                    [ngSwitch]="item.type"
                >
                    <ng-container *ngSwitchCase="filterTypes.multi">
                        <input
                            type="text"
                            *ngIf="item.autocomplete"
                            nz-input
                            [placeholder]="'common.enter-value' | translate"
                            class="dropdown-search"
                            (keyup)="filterOptions($event, item)"
                        />
                        <ul nz-menu class="no-shadow">
                            <li nz-menu-item class="validation-msg label" *ngIf="item.maxSelection">
                                <span
                                    [innerHtml]="
                                        'global-filter.validate-more-selection'
                                            | translate: { number: item.maxSelection - 1 }
                                    "
                                ></span>
                            </li>
                            <li
                                nz-menu-item
                                *ngFor="let menuItem of item.options; trackBy: trackByKey"
                                adsptHeap="advanced-filter-item-multi"
                                [heapData]="{
                                    source: source,
                                    item: item.key,
                                    value: item.autocomplete ? $any(false) : menuItem.key,
                                    'disable/enable': menuItem.selected,
                                }"
                                (click)="selectMultipleSubMenuItem(menuItem, item)"
                            >
                                <label
                                    nz-checkbox
                                    [ngModel]="menuItem.selected"
                                    class="a-no-select"
                                    (ngModelChange)="selectMultipleSubMenuItem(menuItem, item)"
                                    (click)="$event.stopPropagation()"
                                >
                                    <ng-container
                                        *ngIf="
                                            item.customTemplate &&
                                            (columnTemplates[item.key] || defaultFilterTemplates[item.key]) as template
                                        "
                                        [ngTemplateOutlet]="template"
                                        [ngTemplateOutletContext]="{ $implicit: menuItem }"
                                    >
                                    </ng-container>
                                    <span *ngIf="!item.customTemplate">{{ menuItem.text }}</span>
                                </label>
                            </li>
                        </ul>
                        <div
                            class="actions"
                            [ngStyle]="{ 'justify-content': item.autocomplete ? 'flex-end' : 'space-between' }"
                        >
                            <button
                                nz-button
                                nzType="link"
                                (click)="removeSelectedFilter(item)"
                                adsptHeap="advanced-filter-item-multi-cancel"
                                [heapData]="{ source: source, item: item.key }"
                            >
                                {{ 'common.remove' | translate }}
                            </button>
                            <button
                                nz-button
                                nzType="link"
                                adsptHeap="advanced-filter-item-multi-apply"
                                [heapData]="{ source: source, item: item.key }"
                                (click)="applyMultiSelectedFilter(item)"
                            >
                                {{ 'global-filter.apply' | translate }}
                            </button>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="filterTypes.single">
                        <ul nz-menu class="no-shadow">
                            <li
                                nz-menu-item
                                *ngFor="let menuItem of item.options; trackBy: trackByKey"
                                adsptHeap="advanced-filter-item-multi"
                                [heapData]="{
                                    source: source,
                                    item: item.key,
                                    value: item.autocomplete ? $any(false) : menuItem.key,
                                    'disable/enable': menuItem.selected,
                                }"
                                [ngClass]="{ 'ant-menu-item-selected': menuItem.selected }"
                                (click)="selectSingleSubMenuItem(menuItem, item)"
                            >
                                <span>{{ menuItem.text }}</span>
                            </li>
                        </ul>
                    </ng-container>

                    <ng-container *ngSwitchCase="filterTypes.query">
                        <nz-input-group class="subfilter-query-box" nzSearch [nzAddOnAfter]="suffixButton">
                            <input
                                type="text"
                                adsptHeap="advanced-filter-item-query"
                                [heapData]="{ source: source, item: item.key }"
                                nz-input
                                [placeholder]="'common.enter-your-value' | translate"
                                [(ngModel)]="queryValue"
                                (keyup.enter)="applyQuery(item)"
                                class="query-input"
                            />
                        </nz-input-group>
                        <ng-template #suffixButton>
                            <button
                                nz-button
                                nzType="primary"
                                nzSearch
                                [disabled]="!queryValue"
                                adsptHeap="advanced-filter-item-query-apply"
                                [heapData]="{ source: source, item: item.key }"
                                (click)="applyQuery(item)"
                            >
                                {{ 'global-filter.apply' | translate }}
                            </button>
                        </ng-template>
                    </ng-container>

                    <ng-container *ngSwitchCase="filterTypes.queryMultiple">
                        <nz-input-group class="subfilter-query-box" nzSearch [nzAddOnAfter]="suffixButton">
                            <adspt-input-tag
                                class="a-fx-flex"
                                [tags]="queryValue"
                                [placeholder]="'common.enter-your-value' | translate"
                                (tagsUpdated)="queryValue = $event"
                                (enterPressed)="applyQuery(item)"
                                [heapData]="{ source: source, item: item.key }"
                            ></adspt-input-tag>
                        </nz-input-group>

                        <ng-template #suffixButton>
                            <button
                                nz-button
                                nzType="primary"
                                nzSearch
                                [disabled]="!queryValue"
                                adsptHeap="advanced-filter-item-query-apply"
                                [heapData]="{ source: source, item: item.key, '1/2+': queryValue.length < 2 }"
                                (click)="applyQuery(item)"
                            >
                                {{ 'global-filter.apply' | translate }}
                            </button>
                        </ng-template>
                    </ng-container>

                    <ng-container *ngSwitchCase="filterTypes.switch">
                        <div class="switch">
                            <span class="switch-label">{{ item.displayName }}:</span>
                            <nz-switch
                                [nzCheckedChildren]="item.on"
                                adsptHeap="advanced-filter-item-switch"
                                [heapData]="{ source: source, item: item.key, 'disable/enable': item.value }"
                                [nzUnCheckedChildren]="item.off"
                                (ngModelChange)="onSwitchToggle($event, item)"
                                [(ngModel)]="item.value"
                                [nzControl]="false"
                            >
                            </nz-switch>
                        </div>
                    </ng-container>

                    <ng-container *ngSwitchCase="filterTypes.compare">
                        <div class="compare">
                            <h3>{{ item.displayName }}:</h3>
                            <nz-radio-group [(ngModel)]="item.comparator">
                                <div class="a-fx-col a-fx-gap-8">
                                    <ng-container *ngFor="let comparator of compareValuesArray; trackBy: trackByKey">
                                        <div
                                            *ngIf="
                                                !item.enabledComparators?.length ||
                                                item.enabledComparators.includes(comparator.key)
                                            "
                                            nz-radio
                                            [nzValue]="comparator.key"
                                        >
                                            {{ comparator.label | translate }}
                                        </div>
                                    </ng-container>
                                </div>
                            </nz-radio-group>
                            <br />
                            <nz-input-group
                                [nzPrefix]="item.subType === 'currency' ? currency || item.currency : null"
                                [nzSuffix]="item.subType === 'percent' ? '%' : null"
                                nz-tooltip
                                [nzTooltipTitle]="tooltipMetricFilter"
                                *ngIf="item.comparator !== 'RANGE'"
                            >
                                <input
                                    type="text"
                                    nz-input
                                    #inputElement
                                    [ngModel]="item.value"
                                    [placeholder]="'common.input-number' | translate"
                                    (ngModelChange)="updateMetricInputValue($event, item, inputElement)"
                                    (blur)="onBlur(item, inputElement)"
                                />
                            </nz-input-group>
                            <div class="a-fx a-fx-center-center" *ngIf="item.comparator === 'RANGE'">
                                <nz-input-group
                                    [nzPrefix]="item.subType === 'currency' ? currency || item.currency : null"
                                    [nzSuffix]="item.subType === 'percent' ? '%' : null"
                                    nz-tooltip
                                    [nzTooltipTitle]="tooltipMetricFilter"
                                >
                                    <input
                                        type="text"
                                        nz-input
                                        #inputElement
                                        [ngModel]="item.value"
                                        [placeholder]="'common.start' | translate"
                                        (ngModelChange)="updateMetricInputValue($event, item, inputElement)"
                                        (blur)="onBlur(item, inputElement)"
                                    />
                                </nz-input-group>
                                <span>-</span>
                                <nz-input-group
                                    [nzPrefix]="item.subType === 'currency' ? currency || item.currency : null"
                                    [nzSuffix]="item.subType === 'percent' ? '%' : null"
                                    nz-tooltip
                                    [nzTooltipTitle]="tooltipMetricFilter"
                                >
                                    <input
                                        type="text"
                                        nz-input
                                        #inputElement1
                                        [ngModel]="item.endRange"
                                        [placeholder]="'common.end' | translate"
                                        (ngModelChange)="updateMetricInputValue($event, item, inputElement1, true)"
                                        (blur)="onBlur(item, inputElement1, true)"
                                    />
                                </nz-input-group>
                            </div>
                            <p class="error" *ngIf="item.comparator === 'RANGE' && +item?.endRange < +item?.value">
                                {{ 'common.range-error-validation' | translate }}
                            </p>
                            <div class="button-row">
                                <button
                                    nz-button
                                    nzType="link"
                                    (click)="removeSelectedFilter(item)"
                                    adsptHeap="advanced-filter-item-compare-cancel"
                                    [heapData]="{ source: source, item: item.key }"
                                >
                                    {{ 'common.remove' | translate }}
                                </button>
                                <button
                                    nz-button
                                    nzType="link"
                                    [disabled]="
                                        !item.value || (item.comparator === 'RANGE' && +item?.endRange < +item?.value)
                                    "
                                    (click)="onMetricSelected(item)"
                                    adsptHeap="advanced-filter-item-compare-apply"
                                    [heapData]="{ source: source, comparator: item.comparator, item: item.key }"
                                >
                                    {{ 'global-filter.apply' | translate }}
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </nz-dropdown-menu>
        </ng-container>
    </div>

    <span
        class="filters-add a-text-underline-hover a-fx-none a-text-no-wrap"
        [ngClass]="{ disabled: processing }"
        nz-dropdown
        adsptHeap="advanced-filter"
        [heapData]="{ source: source }"
        [heapDisabled]="!source"
        nzTrigger="click"
        [(nzVisible)]="isMainFilterMenuVisible"
        [nzDropdownMenu]="mainMenuContentTemplate"
        [nzDisabled]="processing"
        ><span class="filters-add-label">+</span>{{ 'global-filter.add-filter' | translate }}</span
    >

    <nz-dropdown-menu #mainMenuContentTemplate="nzDropdownMenu">
        <div class="main-menu menu-wrapper">
            <nz-input-group
                *ngIf="showSearch"
                [nzPrefix]="prefixIconSearch"
                adsptHeap="advanced-filter-search-items"
                [heapData]="{ source: source }"
            >
                <input
                    type="text"
                    nz-input
                    [placeholder]="'global-filter.search-placeholder' | translate"
                    [formControl]="queryMainFilterMenu"
                />
            </nz-input-group>
            <ng-template #prefixIconSearch>
                <svg class="adspt-icon">
                    <use xlink:href="#adspt-zoom"></use>
                </svg>
            </ng-template>
            <ul nz-menu class="no-shadow">
                <li nz-menu-item *ngIf="!filtersMenu.length">{{ 'common.no-data' | translate }}</li>
                <ng-container *ngFor="let item of filtersMenu; trackBy: trackByKey">
                    <li
                        *ngIf="!item.isAdded"
                        nz-menu-item
                        (click)="onMenuItemSelected(item)"
                        adsptHeap="advanced-filter-item"
                        [heapData]="{ source: source, item: item.key }"
                        [hidden]="isItemDisabled(item)"
                    >
                        {{ item.displayName }}
                    </li>
                </ng-container>
            </ul>
        </div>
    </nz-dropdown-menu>
</div>

<ng-template #defaultPortfolioFilterTmpl let-data>
    <div class="default-filter-wrapper">
        <p class="a-text-small-label a-text-no-wrap a-text-overflow-ellipsis">{{ data.accountName }}</p>
        <p>{{ data.text }}</p>
    </div>
</ng-template>

<ng-template #defaultLabelFilterTmpl let-data>
    <div class="default-filter-wrapper">
        <p>{{ data.text }}</p>
    </div>
</ng-template>
